// TDS2 SHIM — replace with @salesforce/trailhead-ui equivalents when TDS2 lands.
// Mirrors the prototype's ConnectionErrorState (ChatComponentsPage.tsx 511-545).
// Composes the generic SystemErrorState parent with a circle-alert icon and
// Reconnect / View runtime logs actions.
import React from 'react';
import PropTypes from 'prop-types';
import SystemErrorState from './SystemErrorState';

function CircleAlertIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

function ExternalLinkIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

export default function ConnectionErrorState({
  message,
  mascotUrl,
  eyebrow,
  title = 'Something went wrong.',
  body = "The runtime couldn't compile your agent. Try reconnecting or check the logs for details.",
  toastHeading = 'Whoops, connection lost.',
  toastMessage = 'The agent runtime stopped responding. Reconnect to continue — your work is saved.',
  reconnectLabel = 'Reconnect',
  onReconnect,
  logsHref,
  logsLabel = 'View runtime logs',
}) {
  const actions = (
    <React.Fragment>
      {onReconnect ? (
        <button
          type="button"
          className="tds2-button tds2-button--primary tds2-button--small"
          data-tds2-shim="Button"
          onClick={onReconnect}
        >
          <span className="tds2-button__label">{reconnectLabel}</span>
        </button>
      ) : null}
      {logsHref ? (
        <a
          href={logsHref}
          className="tds2-agentforce-state-card__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {logsLabel}
          <ExternalLinkIcon />
        </a>
      ) : null}
    </React.Fragment>
  );

  return (
    <SystemErrorState
      variant="danger"
      toastHeading={toastHeading}
      toastMessage={toastMessage}
      mascotUrl={mascotUrl}
      icon={<CircleAlertIcon />}
      eyebrow={eyebrow}
      title={title}
      body={<p>{message || body}</p>}
      actions={onReconnect || logsHref ? actions : null}
    />
  );
}

ConnectionErrorState.propTypes = {
  message: PropTypes.string,
  mascotUrl: PropTypes.string,
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  toastHeading: PropTypes.string,
  toastMessage: PropTypes.string,
  reconnectLabel: PropTypes.string,
  onReconnect: PropTypes.func,
  logsHref: PropTypes.string,
  logsLabel: PropTypes.string,
};
